<script lang="ts">
	import ImageInfoCard from '$lib/components/Card/ImageInfoCard.svelte';
	import SectionInformationBlock from '$lib/components/Contentblocks/SectionInformationBlock.svelte';
	import DecoSideGradient from '$lib/assets/DecoSideGradient.png';
	import { getTranslate } from '@tolgee/svelte';
	import type Image from '$lib/components/Image.svelte';
	import { classes } from '$lib/utils';

	export let cards: Array<{ name: string; jobTitle: string; portraitSquare: Image }>;
	export let id: string = '';
	export let additionalClass = '';

	const { t } = getTranslate();

	$: sectionTitle = $t('section-title.teachers.course-detail');
	$: title = $t('title.teachers.course-detail');
	// $: description = $t('description.teachers.course-detail');
</script>

{#if cards && cards.length > 0}
	<SectionInformationBlock
		additionalClass={classes(additionalClass, '')}
		{id}
		{sectionTitle}
		{title}
	>
		<div class="grid grid-cols-1 xs:grid-cols-2 xl:grid-cols-3 gap-14 sm:mr-auto">
			{#each cards as { name, jobTitle, portraitSquare }}
				<ImageInfoCard
					category="Teacher"
					imageSrc={portraitSquare.url}
					sideDecorationImageSrc={DecoSideGradient}
					title={name}
					subtitle={jobTitle}
				/>
			{/each}
		</div>
	</SectionInformationBlock>
{/if}
